import React from "react";
import Typography from "material-ui/Typography";
import {projectsStyle} from "views/projects/style.js";
import withStyles from "material-ui/styles/withStyles";


class ProfileItems extends React.Component{
	constructor(props){
		super(props);
	}
	render(){
		const { label, title, classes } = this.props;

		return(
			<div>
				<Typography className={classes.labelTitle}>{ title }</Typography> 
                <Typography className={classes.label}><strong>{ label }</strong></Typography>
			</div>
		)
	}
}

export default withStyles(projectsStyle)(ProfileItems)


// WEBPACK FOOTER //
// ./src/views/etc/ProfileItems.jsx